import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { I18n } from 'react-redux-i18n'
import { Button, Label, Input, TabPane, Row, Col } from 'reactstrap'
import { customPaymentAct, composerAct } from '../../../../../../redux/actions'
import './styles.scss'
import { lang } from 'utils/helpers'

class Index extends Component {
  constructor(props) {
    super(props)
    this.customPaymentAct = bindActionCreators(customPaymentAct, props.dispatch)
    this.onChatComposer = bindActionCreators(composerAct, props.dispatch)

    this.onSend = this.onSend.bind(this)
    this.onCreateLink = this.onCreateLink.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onReset = this.onReset.bind(this)
  }

  state = {
    urlLink: '',
    DKVUrlLink: '',
  }

  onChange({ target }) {
    this.setState({ urlLink: target.value })
  }

  onReset() {
    this.setState({ urlLink: '', DKVUrlLink: '' })
    this.customPaymentAct.resetCustomPayment(this.props.user.id, true)
  }

  onCreateLink() {
    const { urlLink } = this.state
    const { activeUserID } = this.props

    // Create url and remove last slash from url
    const url = new URL(urlLink.replace(/\/$/, ''))

    // Added param ticket_id
    url.searchParams.set('ticket_id', activeUserID)

    this.setState({ DKVUrlLink: url.toString() })
  }

  onSend() {
    this.onChatComposer.addExternalText(
      `${I18n.t('messages_club_salud_link_is_ready')}▶️ ${this.state.DKVUrlLink} ◀️`
    )
  }

  render() {
    const { tabId } = this.props

    return (
      <TabPane tabId={tabId}>
        {this.state.DKVUrlLink && (
          <div className='w-100 text-right'>
            <i className='pr-2 fa fa-times' onClick={this.onReset} />
          </div>
        )}

        <Row>
          <Col>
            <Label for='urlLink' className='font-weight-bold'>
              {I18n.t('form_link')}
            </Label>
            {this.state.DKVUrlLink ? (
              <p className='mb-2 break-line'>{this.state.DKVUrlLink}</p>
            ) : (
              <Input
                type='url'
                id='urlLink'
                name='urlLink'
                value={this.state.urlLink}
                onChange={this.onChange}
                placeholder='E.g.: https://dkvclubdesalud.dkvseguros.com'
              />
            )}
          </Col>
        </Row>

        {this.state.DKVUrlLink && (
          <Row className='mt-3'>
            <Col>
              <a href={this.state.DKVUrlLink} target='_blank' rel='noopener noreferrer'>
                {I18n.t('dashboard_verify-that-link-works')}
              </a>
            </Col>
          </Row>
        )}

        <Row className='mt-3'>
          <Col className='text-right'>
            <Button color='primary' disabled={!this.state.urlLink} onClick={this.state.DKVUrlLink ? this.onSend : this.onCreateLink}>
              {this.state.DKVUrlLink ? I18n.t('dashboard_copy-to-chat') : lang('dashboard_create-link')}
            </Button>
          </Col>
        </Row>
      </TabPane>
    )
  }
}

export default connect((state) => ({ activeUserID: state.tabs.activeUser }))(Index)
